import {
  DOWNLOAD_DISBURSEMENT,
  ORDER_CONFIRMATION_BULK_UPLOAD,
  ORDER_CONFIRMATION_DOCUMENT,
  ORDER_CONFIRMATION_DOWNLOAD,
  ORDER_CONFIRMATION_FETCH,
  ORDER_CONFIRMATION_FILE_DELETE,
  ORDER_CONFIRMATION_FILE_UPLOAD,
  ORDER_CONFIRMATION_SAVE,
  UPLOAD_DISBURSEMENT,
} from '../../resources/endPoint';

export const uploadDisbursementApi = data => {
  return {
    url: UPLOAD_DISBURSEMENT,
    payload: data,
    method: 'post',
    tag: 'UPLOAD_DISBURSEMENT',
    headers: {'content-type': 'multipart/form-data'},
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};
export const downloadDisbursementApi = data => {
  return {
    url: DOWNLOAD_DISBURSEMENT,
    payload: data,
    method: 'post',
    tag: 'DOWNLOAD_DISBURSEMENT',
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};
export const orderConfirmationDownloadApi = data => {
  return {
    url: ORDER_CONFIRMATION_DOWNLOAD,
    payload: data,
    method: 'get',
    tag: 'ORDER_CONFIRMATION_DOWNLOAD',
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};
export const orderConfirmationBulkUploadApi = data => {
  return {
    url: ORDER_CONFIRMATION_BULK_UPLOAD,
    payload: data,
    method: 'post',
    tag: 'ORDER_CONFIRMATION_BULK_UPLOAD',
    headers: {'content-type': 'multipart/form-data'},
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};
export const orderConfirmationFetchApi = data => {
  return {
    url: ORDER_CONFIRMATION_FETCH,
    payload: data,
    method: 'post',
    tag: 'ORDER_CONFIRMATION_FETCH',
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};
export const orderConfirmationFileUploadApi = data => {
  return {
    url: ORDER_CONFIRMATION_FILE_UPLOAD,
    payload: data,
    method: 'post',
    tag: 'ORDER_CONFIRMATION_FILE_UPLOAD',
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};
export const orderConfirmationFileDeleteApi = data => {
  return {
    url: ORDER_CONFIRMATION_FILE_DELETE,
    payload: data,
    method: 'post',
    tag: 'ORDER_CONFIRMATION_FILE_DELETE',
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};
export const orderConfirmationDocumentApi = data => {
  return {
    url: ORDER_CONFIRMATION_DOCUMENT,
    payload: data,
    method: 'post',
    tag: 'ORDER_CONFIRMATION_DOCUMENT',
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};
export const saveOrderConfirmationApi = data => {
  return {
    url: ORDER_CONFIRMATION_SAVE,
    payload: data,
    method: 'post',
    tag: 'ORDER_CONFIRMATION_SAVE',
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};
